import styled from "styled-components";

export default styled.div`
    display: inline-block;
    font-size: 30px;
    margin: 0 0 30px 20px;
    cursor: pointer;
    
    @media only screen and (min-width: 1100px) {
        margin: 10px 15px 0 0;
    }
`;